import React from 'react';
import { Box, Button, Typography } from '@mui/material';

/**
 * Catches render crashes (including browser-Translate mangling the React DOM)
 * and offers a full reload instead of a permanent white screen.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('App ErrorBoundary caught:', error, info?.componentStack);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box
          role="alert"
          sx={{
            minHeight: '100dvh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 2,
            px: 3,
            textAlign: 'center',
            bgcolor: '#f8fafc',
            color: '#0f172a',
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: 700 }}>
            Something went wrong
          </Typography>
          <Typography variant="body2" sx={{ color: '#64748b', maxWidth: 360 }}>
            The page failed to render. This can happen if the browser tried to
            translate the app. Reload to continue.
          </Typography>
          <Button variant="contained" onClick={this.handleReload} sx={{ mt: 1 }}>
            Reload
          </Button>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
